<div class="selector-color">
  <div class="selector-color__cabecera">
    <div class="selector-color__cabecera-texto">
      <span class="selector-color__titulo">Color</span>
      @if (rolNombre) {
        <span class="selector-color__subtitulo">Selecciona un color para el rol {{ rolNombre }}.</span>
      } @else {
        <span class="selector-color__subtitulo">Selecciona un color.</span>
      }
    </div>
    <button
      type="button"
      class="selector-color__cerrar"
      aria-label="Cerrar selector de color"
      (click)="cancelarSeleccion()">
      ✕
    </button>
  </div>

  <div class="selector-color__paleta">
    @for (color of paleta; track color.codigo) {
      <div class="selector-color__item-wrapper">
        <button
          type="button"
          class="selector-color__circulo"
          [style.background-color]="color.codigo"
          [class.selector-color__circulo--seleccionado]="estaSeleccionado(color.codigo)"
          [class.selector-color__circulo--ocupado]="estaOcupado(color.codigo)"
          (click)="seleccionarColor(color.codigo)"
          [attr.aria-label]="'Seleccionar color ' + color.nombre"
          [attr.title]="estaOcupado(color.codigo) ? 'Asignado a: ' + getRolOcupado(color.codigo) : color.nombre">
        </button>
        @if (estaOcupado(color.codigo)) {
          <span class="selector-color__ocupado-badge">{{ getRolOcupado(color.codigo) }}</span>
        }
      </div>
    }
  </div>

  @if (colorTemporal() && estaOcupado(colorTemporal()!)) {
    <div class="selector-color__advertencia">
      <span class="selector-color__advertencia-icono">⚠️</span>
      <span>Este color ya está asignado al rol <strong>{{ getRolOcupado(colorTemporal()!) }}</strong></span>
    </div>
  }

  <div class="selector-color__acciones">
    <button
      type="button"
      class="selector-color__btn-cancelar"
      (click)="cancelarSeleccion()">
      Cancelar
    </button>
    <button
      type="button"
      class="selector-color__btn-confirmar"
      [disabled]="!colorTemporal()"
      (click)="confirmar()">
      Confirmar
    </button>
  </div>
</div>
